import { Component,Input, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import swal from "sweetalert2";

interface DialogData {
  datospreca: any;
}
@Component({
  selector: 'app-modal-ccr',
  templateUrl: './modal-ccr.component.html',
  styleUrls: ['./modal-ccr.component.scss']
})
export class ModalCcrComponent implements OnInit {
  listindexactive = [];
  listindexfiniquito = []
  listindexcancelacion = []
  descripcion=''
  constructor(public dialogRef: MatDialogRef<ModalCcrComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
   }

  ngOnInit(): void {
  }
  selectType(event) {
    
  }
  changeindexactive(index) {
    if (this.listindexactive.includes(index)) {
      const aux = this.listindexactive.indexOf(index);
      this.listindexactive.splice(aux, 1);
    } else {
      this.listindexactive.push(index);
    }
  }
  changeindextype(index,type) {
    if (!this.listindexfiniquito.includes(index) && !this.listindexcancelacion.includes(index)) {
      if (type == 1) {
        this.listindexfiniquito.push(index);
      } else {
        this.listindexcancelacion.push(index)
      }
    } else if (this.listindexfiniquito.includes(index) && type == 2) { //si ya esta activo finiquito y se dio click en cancelación
      const aux = this.listindexfiniquito.indexOf(index);
      this.listindexfiniquito.splice(aux, 1);
      this.listindexcancelacion.push(index)
    }else if (this.listindexfiniquito.includes(index) && type == 1) {//si ya esta activo finiquito y se dio click en finiquito
      const aux = this.listindexfiniquito.indexOf(index);
      this.listindexfiniquito.splice(aux, 1);
    }
    else if (this.listindexcancelacion.includes(index) && type == 1) {//si ya esta activo cancelacion y se dio click en finiquito
      this.listindexfiniquito.push(index);
      const aux = this.listindexcancelacion.indexOf(index);
      this.listindexcancelacion.splice(aux, 1);
    } else if (this.listindexcancelacion.includes(index) && type == 2) {//si ya esta activo cancelación y se dio click en cancelación
      const aux = this.listindexcancelacion.indexOf(index);
      this.listindexcancelacion.splice(aux, 1);
    }
  }
  setFormatDate(date: string) {
    let dia = date.substring(0, 2);
    let mes = date.substring(2, 4);
    let ano = date.substring(4);
    return dia+'/'+mes+'/'+ano;
  }
  changeSatus(status) {
    if (status == 'aprobar') {
      if (this.descripcion == '') {
        this.showNotification('Alerta','Debe ingresar observaciones.')
      }
      else if (this.validateForm()) {
        this.data.datospreca.forEach(element => {
          if (this.listindexfiniquito.includes(element.correlativo)) {
            element.aproFiniquito = true
            element.aproCancelacion=false
          } else {
            element.aproFiniquito = false
            element.aproCancelacion=true
          }
          let result = {
            productos: this.data.datospreca,
            descripcion: this.descripcion
          }
          this.dialogRef.close(result)
        });
        
      } else {
        this.showNotification('Alerta','Debe seleccionar un comprobante para todos los productos.')
      }
    }
  }
  validateForm() {
    let result=true
    this.data.datospreca.forEach(element => {
      if (!this.listindexfiniquito.includes(element.correlativo) && !this.listindexcancelacion.includes(element.correlativo)) {
        result=false
      }
    });
    return result
  }
  showNotification(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
